export default "__VITE_ASSET__CpEhGsVO__"